import { computed, ref } from "vue";
interface UserInfo {
  id: number;
  uuid: string;
  email: string;
  username: string;
  manager_permissions: string[];
  default_path: string;
  colors: string[];
  permissions: string[];
  disclaimer: string;
  navbar_color: string;
  assets_api_key: string;
  can_integrate?: boolean;
  is_trial?: boolean;
  available_until?: string | null;
  util_days_fill_holes?: number;
}

const userInfo = ref<UserInfo | null>(null);

export function useUserStore() {
  const sessionInfoStr = localStorage.getItem("session_info");
  if (!userInfo.value && sessionInfoStr && sessionInfoStr !== "null") {
    userInfo.value = JSON.parse(sessionInfoStr);
  } else if (!sessionInfoStr || sessionInfoStr === "null") {
    userInfo.value = null;
  } //Fallback when restarting browser
  
  const setUserInfo = (info: UserInfo | null) => {
    localStorage.setItem("session_info", JSON.stringify(info));
    userInfo.value = info;
  };

  const resetUserInfo = () => {
    localStorage.removeItem("session_info");
    userInfo.value = null;
  };

  const getUserInfo = computed<UserInfo | null>(
    () => userInfo?.value ?? JSON.parse(localStorage.getItem("session_info")),
  );

  const hasManagerPermission = (permission: string) => {
    if (!userInfo.value?.manager_permissions) return false;
    return userInfo.value.manager_permissions.includes(permission);
  };

  const hasAnyCustomizePermission = (permissions: string[]) => {
    if (!userInfo.value?.manager_permissions) return false;
    return permissions.some((permission) =>
      userInfo?.value.manager_permissions.includes(permission),
    );
  };

  const hasAnyConfigurationPermission = (permissions: string[]) => {
    if (!userInfo.value?.manager_permissions) return false;
    return permissions.some((permission) =>
      userInfo?.value.manager_permissions.includes(permission),
    );
  };

  return {
    userInfo,
    setUserInfo,
    resetUserInfo,
    hasManagerPermission,
    getUserInfo,
    hasAnyCustomizePermission,
    hasAnyConfigurationPermission,
  };
}
